export class ThemeEvents {
  static discountUpdate = 'discount:update';
}

export class DiscountUpdateEvent extends Event {
  constructor(resource, sourceId) {
    super(ThemeEvents.discountUpdate, { bubbles: true });
    this.detail = { resource, sourceId };
  }
}

document.addEventListener('cart:update', () => {
  localStorage.removeItem('shippingRates');
  localStorage.removeItem('selectedShippingRate');
});
